import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import k8DashboardSlice from "./slices/k8/dashboardSlice";
import tasksFiltersSlice from "./slices/seo/tasksFiltersSlice";
import sideNavBarTabsSlice from "./slices/sideNavBarTabsSlice";
import taskAllocationSlice from "./slices/k8/taskAllocationSlice";
import StateSlice from "./slices/Tev/stateSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    tevState: StateSlice,
    k8Dashboard: k8DashboardSlice,
    taskFilters: tasksFiltersSlice,
    sideNavBarTabs: sideNavBarTabsSlice,
    taskAllocation: taskAllocationSlice,
  },
});
